export default "__VITE_ASSET__DDZYR9kW__"